module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog\" title=\"")
    ; __append(escapeFn( title ))
    ; __append("\">\r\n    <label>")
    ; __append(escapeFn( text ))
    ; __append("</label>\r\n    <div title=\"")
    ; __append(escapeFn( text ))
    ; __append("\">\r\n        <textarea id=\"xmlResponse\" style=\"width:665px; height:352px;\"></textarea>\r\n    </div>\r\n</div>")
  }
  return __output;

}